import Checkbox from "antd/lib/checkbox/Checkbox";
import React, { useContext } from "react";
import { Rules } from "./Security";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";

interface PasswordValidatorProps {
    id?: string;
    passwordRules: Rules;
}

const PasswordValidator = ({ id, passwordRules }: PasswordValidatorProps) => {
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;
    return (
        <div className={"password-rules"} id={id}>
            <p style={isDesktop ? { color: "black" } : null}>Your password must:</p>
            <ul>
                {Object.values(passwordRules).map(({ description, checked }, index) => (
                    <li key={index}>
                        <Checkbox key={index} checked={checked} tabIndex={-1}>
                            <span style={isDesktop ? { color: "black" } : null}>{description}</span>
                        </Checkbox>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PasswordValidator;
